export type SignUpResponse = {
  success: boolean;
  message?: string;
  redirect?: string;
  regionUnavailable?: boolean;
  organizationCreated?: boolean;
};

/**
 * True only when the server created an account. Waitlist (`regionUnavailable`)
 * and honeypot (`success: true` with neither `organizationCreated` nor `redirect`)
 * also come back as HTTP 200 with `success: true`, and must not count as GTM
 * conversions. New orgs omit `redirect` (stay on /finish-registration) and send
 * `organizationCreated` instead; invited members join an existing org and still
 * signal via `redirect`.
 */
export function isAccountSignUp(data: SignUpResponse): boolean {
  return (
    data.success === true &&
    !data.regionUnavailable &&
    (data.organizationCreated === true || Boolean(data.redirect))
  );
}
